import { render, staticRenderFns } from "./SoftwareTester.vue?vue&type=template&id=97f9390a&"
import script from "./SoftwareTester.vue?vue&type=script&lang=js&"
export * from "./SoftwareTester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports